import { isAxiosError } from 'axios'
import Api from 'services/Api'
import LocalStorage from 'services/LocalStorage'
import { GetChangesResponse } from 'types/api/changes'
import { LocalStorageKey } from 'types/services/localStorage'
import { isPermissionOrSubscriptionError } from 'utils/api/codes'
import { isGuest } from 'utils/user'

import { LOGIN_URL } from './auth'

export const API_CHANGES = '/general/changes'

export interface GetChangesBody {
  LastUpdate: string | null | undefined
  DeviceChangeID: string | null | undefined
  ForGroupsID: string[] | null | undefined
}

export async function getChanges(
  body: GetChangesBody
): Promise<GetChangesResponse> {
  const syncingUserId = LocalStorage.get(LocalStorageKey.USER_ID)
  const response = await Api.post(API_CHANGES, { ...body }).catch(
    async (error) => {
      // Preserve the sign-in transition for background sync callers too. The
      // refresh interceptor may already have ended the session.
      if (
        isSyncAuthenticationError(error) &&
        !isGuest() &&
        syncingUserId === LocalStorage.get(LocalStorageKey.USER_ID) &&
        LocalStorage.get(LocalStorageKey.ACCESS_TOKEN) &&
        typeof window.processLogout === 'function'
      ) {
        await window.processLogout()
      }
      throw error
    }
  )
  if (!Array.isArray(response.data?.results)) {
    throw new Error('Invalid changes response')
  }
  return parseDataWithCast(response.data)
}

// Called after the API interceptor has attempted the normal credential refresh.
export function isSyncAuthenticationError(error: unknown): boolean {
  if (!isAxiosError(error)) return false
  const status = error.response?.status
  if (isPermissionOrSubscriptionError(error)) {
    return false
  }
  return (
    status === 401 ||
    status === 403 ||
    status === 404 ||
    (Boolean(error.config?.url?.includes(LOGIN_URL)) &&
      (status === 400 || status === 422))
  )
}

export function parseDataWithCast(data: any) {
  return JSON.parse(JSON.stringify(data), (key, value) => {
    const propertiesToCast = ['Status'] // Which properties should be converted from number to string
    if (propertiesToCast.includes(key)) {
      return String(value)
    }
    return value
  })
}
